import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/relatorio-viagem-motorista`

    return {
        index(queryParms = {}) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        list(queryParms = {}) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        getMotoristas(queryParms = {}) {
            return repository.get(`${baseUrl}/motorista?${urlUtil.serialize(queryParms)}`)
        }
    }
}